import React from 'react'
import Files from './Files'

// TODO: figure out the reason why the Files component was not re-rendered
// upon route change, if it is put directly in the App.js component.
// But when it is put inside Starred component like this, it was re-rendered correctly.
export default function Pending({ isPending, isRejected }) {
  return <Files isPending={isPending} isRejected={isRejected} />
}
